import { ArrowUpRight, Check, Layers3 } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../icp-screener.css';

export function ScreenerSwitch({ active }: { active: 'soon' | 'icpswap' }) {
  return <nav className="screener-switch" aria-label="Choose a token market">
    <div className="screener-switch-label"><Layers3 size={13} /><span>CHOOSE YOUR MARKET</span><span>One home for the ICP ecosystem</span></div>
    <div className="screener-switch-options">
      <Link to="/" className={`screener-option screener-option-soon ${active === 'soon' ? 'selected' : ''}`} aria-current={active === 'soon' ? 'page' : undefined}>
        <span className="screener-option-mark"><img src="/brand/owl.svg" width="55" height="55" alt="" /></span>
        <span className="screener-option-copy"><strong>Soon<span>screener</span></strong><span>Launches, curves & community profiles</span></span>
        <span className="screener-option-action">{active === 'soon' ? <><span>Viewing</span><Check size={17} /></> : <><span>Explore Soon</span><ArrowUpRight size={18} /></>}</span>
      </Link>
      <Link to="/icpswap" className={`screener-option screener-option-icp ${active === 'icpswap' ? 'selected' : ''}`} aria-current={active === 'icpswap' ? 'page' : undefined}>
        <span className="screener-option-mark icp-screener-mark" aria-hidden="true">∞</span>
        <span className="screener-option-copy"><strong>ICP <span>Screener</span></strong><span>Discover tokens trading on ICPSwap</span></span>
        <span className="screener-option-action">{active === 'icpswap' ? <><span>Viewing</span><Check size={17} /></> : <><span>Explore ICPSwap</span><ArrowUpRight size={18} /></>}</span>
      </Link>
    </div>
  </nav>;
}
